<template>
    <div class="shareList">
        <Search :list="qrTemplateTypeList" placeholder="输入海报名称" :activeStatus="activeStatus" @click="search" />
        <Tab :list="tabList" :activeTab="activeTab" @click='onTab' />
        <List v-model="listLoading" :finished="finished" finished-text="没有更多了" @load="getList">
            <div class="shareItem" v-for="(item, index) in list" :key="index">
                <img :src="item.urlPath" alt="">
                <div class="contentView">
                    <h2 class="title van-ellipsis">标题：{{item.title}}</h2>
                    <p class="content van-multi-ellipsis--l3">内容：{{item.content}}</p>
                    <p class="download">下载量：{{item.download}}次</p>
                    <div class="btnView">
                        <Button @click="copy(index)" :class="`copy${index}`" :data-clipboard-text="item.content">复制文案</Button>
                        <Button @click="toPage(`/shareDetails/${item.id}`)">下载图片</Button>
                    </div>
                </div>
            </div>
        </List>
    </div>
</template>

<script>
    /*
    * 文案列表
    * */
    import Search from '../../../../components/Search'
    import Tab from '../../../../components/Tab'
    import {List, Button} from 'vant'
    import {treatmentList} from "../../../../api/share";
    import Clipboard from 'clipboard';

    export default {
        name: "ShareList",
        components: {
            Search,
            Tab,
            List,
            Button
        },
        data() {
            return {
                qrTemplateTypeList: [
                    {
                        text: '全部',
                        value: ''
                    }, {
                        text: '政策',
                        value: 'POLICY'
                    }, {
                        text: '节假日',
                        value: 'HOLIDAYS'
                    }, {
                        text: '专题',
                        value: 'TOPIC'
                    }
                ],
                activeStatus: {
                    text: '全部',
                    value: ''
                },
                tabList: [
                    {
                        text: '最新创建',
                        value: 'NEW_ARRIVAL'
                    }, {
                        text: '下载最高',
                        value: 'HIGH_DOWNLOADS'
                    }
                ],
                activeTab: {
                    text: '最新创建',
                    value: 'NEW_ARRIVAL'
                },
                listLoading: false,
                finished: false,
                page: 1,
                list: [],
                searchTitle: '',
            }
        },
        created() {
            let {status, tab} = this.$route.query;
            switch (status) {
                case 'POLICY':
                    this.activeStatus = {
                        text: '政策',
                        value: 'POLICY'
                    };
                    break;
                case 'HOLIDAYS':
                    this.activeStatus = {
                        text: '节假日',
                        value: 'HOLIDAYS'
                    };
                    break;
                case 'TOPIC':
                    this.activeStatus = {
                        text: '专题',
                        value: 'TOPIC'
                    };
                    break;
            }
            switch (tab) {
                case 'NEW_ARRIVAL':
                    this.activeTab = {
                        text: '最新创建',
                        value: 'NEW_ARRIVAL'
                    };
                    break;
                case 'HIGH_DOWNLOADS':
                    this.activeTab = {
                        text: '下载最高',
                        value: 'HIGH_DOWNLOADS'
                    };
                    break;
            }
        },
        methods: {
            copy(index) {
                let clipboard = new Clipboard(`.copy${index}`);
                let _this = this;
                clipboard.on('success', e => {
                    _this.toast({
                        text: '复制成功',
                        icon: 'success'
                    });
                    // 释放内存
                    clipboard.destroy()
                });
                clipboard.on('error', e => {
                    // 不支持复制
                    console.log('该浏览器不支持自动复制');
                    // 释放内存
                    clipboard.destroy()
                });
            },
            search(obj) {
                this.searchTitle = obj.value;
                this.activeStatus.value = obj.status;
                this.page = 1;
                this.list = [];
                this.getList();
            },
            onTab(obj) {
                this.activeTab = obj;
                this.page = 1;
                this.list = [];
                this.getList();
            },
            getList() {
                let data = {};
                data.type = this.activeTab.value;
                data.qrTemplateType = this.activeStatus.value;
                data.page = this.page;
                data.title = this.searchTitle;
                treatmentList(data).then(res => {
                    this.list = [...this.list, ...res.records];
                    // 加载状态结束
                    this.listLoading = false;
                    if (res.records.length < 10) {
                        // 数据全部加载完成
                        this.finished = true;
                        return;
                    }
                    this.page++;
                })
            }
        }
    }
</script>

<style lang='less' scoped>
    .shareList {
        min-height: 100vh;
        padding-top: 2.67vw;
        background-color: #f8f8f8;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        .shareItem {
            display: flex;
            justify-content: space-between;
            width: 93.87vw;
            height: 52.13vw;
            margin: 0 auto 2.67vw;
            padding: 4.8vw 5.73vw 4.67vw 6.4vw;
            background-color: #ffffff;
            box-shadow: 0 0.53vw 1.33vw -0.53vw rgba(0, 0, 0, 0.08);
            border-radius: 2.67vw;
            box-sizing: border-box;
            img {
                width: 24vw;
                height: 42.67vw;
                margin-right: 5.6vw;
            }
            .contentView {
                display: flex;
                flex: 1;
                flex-direction: column;
                height: 100%;
                .title {
                    width: 52vw;
                    line-height: 10.8vw;
                    font-size: 4vw;
                    color: #333333;
                }
                .content {
                    font-size: 3.2vw;
                    color: #1c1c1c;
                }
                .download {
                    margin-bottom: 0.87vw;
                    line-height: 11vw;
                    font-size: 3.2vw;
                    color: #979797;
                }
                .btnView {
                    display: flex;
                    button {
                        width: 18.8vw;
                        height: 6.67vw;
                        padding: 0;
                        border: none;
                        line-height: 6.67vw;
                        background-color: #43a2fe;
                        border-radius: 1.2vw;
                        font-size: 2.93vw;
                        color: #ffffff;
                        &:last-child {
                            margin-left: 8vw;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/share/list/ShareList.vue